import styled from 'styled-components';
import { CssFuncs } from '../../../foundation/css/css.funcs';

const Container = styled.div.withConfig({
  componentId: 'node-item_container',
  displayName: 'NodeItem.Container',
})`
  ${CssFuncs.css.asAbsoluteContainer()}
`;

const SelfDndLineAnchor = styled.div.withConfig({
  componentId: 'node-item_self-dnd-line-anchor',
  displayName: 'NodeItem.SelfDndLineAnchor',
})`
  ${CssFuncs.css.absolute({
    x: '0px',
    top: '-1px',
  })}
  ${CssFuncs.css.size({ y: '0px' })}
  ${CssFuncs.css.yCenterAlignInside()}
`;

const NewChildDndLineAnchor = styled.div.withConfig({
  componentId: 'node-item_new-child-dnd-line-anchor',
  displayName: 'NodeItem.NewChildDndLineAnchor',
})`
  ${CssFuncs.css.absolute({
    x: '0px',
    bottom: '-1px',
  })}
  ${CssFuncs.css.size({ y: '0px' })}
  ${CssFuncs.css.yCenterAlignInside()}
`;

const DndLine = styled.div.withConfig({
  componentId: 'node-item_dnd-line',
  displayName: 'NodeItem.DndLine',
})`
  ${CssFuncs.css.size({ y: '2px', x: '100%' })}
  ${CssFuncs.css.margin({ x: '6px' })}
  background-color: #007FFF;

  ${CssFuncs.css.asAbsoluteContainer()}
`;

const DndLineEnd1 = styled.div.withConfig({
  componentId: 'node-item_dnd-line-end-1',
  displayName: 'NodeItem.DndLineEnd1',
})`
  ${CssFuncs.css.absolute({
    top: '-2px',
    left: '-3px',
  })}
  ${CssFuncs.css.size({ xy: '6px' })}
  border-radius: 3px;
  background-color: #007fff;
`;

const DndLineEnd2 = styled.div.withConfig({
  componentId: 'node-item_dnd-line-end-1',
  displayName: 'NodeItem.DndLineEnd1',
})`
  ${CssFuncs.css.absolute({
    top: '-2px',
    right: '-3px',
  })}
  ${CssFuncs.css.size({ xy: '6px' })}
  border-radius: 3px;
  background-color: #007fff;
`;

export const NodeItemStyle = {
  Container,
  SelfDndLineAnchor,
  NewChildDndLineAnchor,
  DndLine,
  DndLineEnd1,
  DndLineEnd2,
};
